import { lazy } from 'react';

// project imports
import Loadable from 'jsx/components/utilities/Loadable';
import MinimalLayout from 'jsx/layout/MinimalLayout';

// maintenance routing
const PagesError = Loadable(lazy(() => import('jsx/pages/other/Error')));

// landing & contact-us routing
const PagesLanding = Loadable(lazy(() => import('jsx/pages/landing')));
const PagesContactUS = Loadable(lazy(() => import('jsx/pages/contact-us')));
const ThankYou = Loadable(lazy(() => import('jsx/pages/contact-us/ThankyouPage')));
const PagesFaqs = Loadable(lazy(() => import('jsx/pages/other/Faqs')));
const PagesPrivacyPolicy = Loadable(lazy(() => import('jsx/pages/other/PrivacyPolicy')));
const TaxCalculator = Loadable(
    lazy(() => import('jsx/pages/TaxCalculator/index').catch(() => import('jsx/pages/other/Error')))
);

const Notification = Loadable(
    lazy(() => import('jsx/pages/Notifications/Notiffication').catch(() => import('jsx/pages/other/Error')))
);
const Features = Loadable(lazy(() => import('jsx/pages/Features')));
const About = Loadable(lazy(() => import('jsx/pages/About')));
const PagesDemo = Loadable(lazy(() => import('jsx/pages/demo')));
const Reviews = Loadable(lazy(() => import('jsx/pages/Reviews')));


// ==============================|| NOAUTH ROUTING ||============================== //

const NoAuthRoutes = {
    path: '/',
    element: <MinimalLayout />,
    children: [
        {
            path: '/pages/error',
            element: <PagesError />
        },
        {
            path: '/pages/landing',
            element: <PagesLanding />
        },
        {
            path: '/contactus',
            element: <PagesContactUS />
        },
        {
            path: '/thank-you',
            element: <ThankYou />
        },
        {
            path: '/thankyou',
            element: <ThankYou />
        },
        {
            path: '/pages/faqs',
            element: <PagesFaqs />
        },
        {
            path: '/pages/privacy-policy',
            element: <PagesPrivacyPolicy />
        },
        {

            path: '/notifications',
            element: <Notification />
        },
        {
            path: '/taxcalculator',
            element: <TaxCalculator />
        },
        {
            path: '/features',
            element: <Features />
        },
        {
            path: '/about',
            element: <About />
        },
        {
            path: '/book-demo',
            element: <PagesDemo />
        },
        {
            path: '/reviews',
            element: <Reviews />
        },

    ]
};

export default NoAuthRoutes;
